import styled from '@themes/theme'

export const UpdatePopupWrap = styled.div`
  z-index: 1;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 300px;
  .close-btn.update-cls-btn {
    top: -48px;
    right: 0;
    border: 1px solid ${props => props.theme.color.themeTxt};
    &.pc {
      left: 50%;
      transform: translateX(280%);
    }
    &::before, &::after {
      left: 13px;
    }
  }
  .update-banner-btn {
    width: 100%;
    height: auto;
    border-radius: 0;
    img {
      width: 100%;
      height: auto;
    }
  }
`
